var exports = {
  "J": "Label__JwbbhC",
  "l": "Banner___sPb1T",
};

module.exports = exports;
